<template>
  <div class="prize-container">
    <div class="prize-header">
      <span class="prize-title">
        {{ prizs.name }}
        <i class="el-icon-info"></i>
      </span>
    </div>

    <div class="prize-content">
      <el-form-item label="奖品名称" required>
        <el-input v-model="prizs.name" placeholder="请输入奖品名称" :clearable="true"></el-input>
      </el-form-item>

      <el-form-item label="数量" required>
        <el-input v-model.number="prizs.count" placeholder="请输入数量" :clearable="true"></el-input>
      </el-form-item>

      <el-form-item label="奖品Icon" required>
        <uploadImg v-model="prizs.icon" :imgSize="1" :text="['图片大小500kb以内', '图片格式png/jpg/gif', '图片宽度248px,高度236px']">
        </uploadImg>
      </el-form-item>

      <el-form-item label="类型">
        <el-radio-group v-model="prizs.type" @change="skuType" class="prize-type-group">
          <div class="prize-type-row">
            <el-radio :label="0">无奖品</el-radio>
            <el-radio :label="1">实体物品</el-radio>
            <el-radio :label="2">克拉数</el-radio>
            <el-radio :label="3">优惠券</el-radio>
            <el-radio :label="4">经验值</el-radio>
          </div>
          <div class="prize-type-row">
            <el-radio :label="5">抽奖机会</el-radio>
            <el-radio :label="6">勋章</el-radio>
            <el-radio :label="7">属性值</el-radio>
            <el-radio :label="8">机会卷</el-radio>
            <el-radio :label="9">打卡任务</el-radio>
          </div>
          <div class="prize-type-row">
            <el-radio :label="10">委托卡片</el-radio>
            <el-radio :label="11">大赛资格</el-radio>
            <el-radio :label="12">地图资格</el-radio>
            <el-radio :label="13">现金红包</el-radio>
            <el-radio :label="14">成长币</el-radio>
          </div>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="虚拟物品值"
        v-if="prizs.type !== 0 && prizs.type !== 2 && prizs.type !== 3 && prizs.type !== 13 && prizs.type !== 14"
        required>
        <el-input v-if="prizs.type === 1 || prizs.type === 4" v-model="prizs.value" placeholder="输入数量"
          :clearable="true"></el-input>
        <el-select v-if="prizs.type == 3" clearable class="filter-item" v-model="prizs.value" placeholder="请选择优惠券"
          style="margin-right: 20px;">
          <el-option v-for="item in couponsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-select v-if="prizs.type == 5" clearable class="filter-item" v-model="prizs.value" placeholder="请选择抽奖"
          style="margin-right: 20px;">
          <el-option v-for="item in rafflesList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-select v-if="prizs.type == 6" clearable class="filter-item" v-model="prizs.value" placeholder="请选择勋章"
          style="margin-right: 20px;">
          <el-option v-for="item in medalsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-select v-model="prizs.value" placeholder="请选择属性" v-if="prizs.type == 7">
          <el-option-group v-for="group in options" :key="group.label" :label="group.label">
            <el-option v-for="item in group.options" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-option-group>
        </el-select>
        <el-select v-if="prizs.type == 8" clearable class="filter-item" v-model="prizs.value" placeholder="请选择委托"
          style="margin-right: 20px;">
          <el-option v-for="getCR in getCRsList" :key="getCR.id" :label="getCR.name" :value="getCR.id"></el-option>
        </el-select>
        <el-select v-if="prizs.type == 9" clearable filterable class="filter-item" v-model="prizs.value"
          placeholder="请选择打卡任务" style="margin-right: 20px;">
          <el-option v-for="getCR in getsThemeList" :key="getCR.id" :label="getCR.title" :value="getCR.id"></el-option>
        </el-select>
        <el-select v-if="prizs.type == 10" clearable class="filter-item" v-model="prizs.value2" placeholder="请选择委托"
          style="margin-right: 20px;" @change="skusType">
          <el-option v-for="getCR in getCRsList" :key="getCR.id" :label="getCR.name" :value="getCR.id"></el-option>
        </el-select>
        <el-select v-if="prizs.type == 10" clearable class="filter-item" v-model="prizs.value" placeholder="请选择委托卡片"
          style="margin-right: 20px;" :disabled="prizs.value2 == ''">
          <el-option v-for="getCR in prizs.getCardList" :key="getCR.id"
            :label="getCR.companyName + ' -酬劳:' + getCR.reward" :value="getCR.id"></el-option>
        </el-select>
        <el-select v-if="prizs.type == 11" clearable class="filter-item" v-model="prizs.value" placeholder="请选择大赛"
          style="margin-right: 20px;">
          <el-option v-for="item3 in megagameList" :key="item3.id" :label="item3.title" :value="item3.id"></el-option>
        </el-select>
        <el-select v-if="prizs.type == 12" clearable class="filter-item" v-model="prizs.value" placeholder="请选择地图"
          style="margin-right: 20px;">
          <el-option v-for="item3 in mapList" :key="item3.id" :label="item3.name" :value="item3.id"></el-option>
        </el-select>
      </el-form-item>
    </div>
  </div>
</template>

<script>
import { getArrList } from '@/api/demo/discount/index'
import { getLuckList } from '@/api/demo/luckDraw/index'
import { getMedalList } from '@/api/demo/medal/index'
import { attList } from '@/api/demo/attributes/index'
import { getCRList, getCard } from '@/api/demo/CommissionRelate/index'
import uploadImg from '@/components/uploadImage/index.vue'
import { getThemeList } from '@/api/demo/punchInActivity/index'
import { megagameList } from '@/api/demo/competition/index'
import { getMapList } from '@/api/demo/map/index'

export default {
  name: 'prize',
  props: {
    prizs: {
      type: Object,
      default: () => { }
    }
  },
  components: {
    uploadImg
  },
  data () {
    return {
      couponsList: [], // 优惠券列表
      rafflesList: [], // 抽奖列表
      medalsList: [], // 勋章列表
      getCRsList: [], // 委托管理
      getsThemeList: [],
      megagameList: [],
      mapList: [],
      listLoading: false,
      options: [
        { label: '亲密关系', options: [] },
        { label: '气质特征', options: [] },
        { label: '能力属性', options: [] }
      ]
    }
  },
  created () {
    console.log('prizs', this.prizs)
    let that = this
    that.couponList()
    that.raffleList()
    that.medalList()
    that.getCRList()
    that.getAttributes()
    that.getThemesList()
    that.getMegagameList()
    this.getMapList()
  },
  methods: {
    // 大赛
    getMegagameList () {
      let that = this
      let listQuery = {
        currentPage: 1,
        pageSize: 100,
        keyword: '',
        classifyId: ''
      }
      megagameList(listQuery).then(res => {
        that.megagameList = res.records
      })
    },
    getMapList () {
      let that = this
      let listQuery = {
        currentPage: 1,
        pageSize: 100,
        keyword: '',
        classifyId: ''
      }
      getMapList(listQuery).then(res => {
        that.mapList = res.records
      })
    },
    skuType (e) {
      let that = this
      that.prizs.type = e
    },
    getCardsList (e) {
      let that = this
      getCard(e).then(res => {
        that.prizs.getCardList = res
      })
    },
    skusType (e) {
      let that = this
      if (e == '') {
      } else {
        that.getCardsList(e)
      }
    },
    // 获取打卡任务
    getThemesList () {
      let that = this
      let listQuery = {
        currentPage: 1,
        pageSize: 2000,
        classifyId: null,
        keyword: null,
        status: 1
      }
      getThemeList(listQuery).then(res => {
        that.getsThemeList = res.records
      })
    },
    // 优惠券
    couponList () {
      let that = this
      let listQuery = {
        currentPage: 1,
        pageSize: 100,
        keyword: '',
        stat: 1,
        type: ''
      }
      getArrList(listQuery).then(res => {
        that.couponsList = res.records
      })
    },
    // 抽奖列表
    raffleList () {
      let that = this
      let listQuery = {
        currentPage: 1, // 当前页数
        name: null, // 名称
        pageSize: 200, // 每页显示的大小
        status: 1 // 状态
      }
      getLuckList(listQuery).then(res => {
        that.rafflesList = res.records
      })
    },
    // 勋章列表
    medalList () {
      let that = this
      let listQuery = {
        currentPage: 1, // 当前页数
        pageSize: 200 // 每页显示的大小
      }
      getMedalList(listQuery).then(res => {
        that.medalsList = res.records
      })
    },
    getCRList () {
      let that = this
      let listQuery = {
        currentPage: 1, // 当前页数
        pageSize: 200, // 每页显示的大小
        status: 1
      }
      getCRList(listQuery).then(res => {
        that.getCRsList = res.records
      })
    },
    // 获取属性相关
    getAttributes () {
      let listQuery = {
        currentPage: 1,
        pageSize: 40
      }
      attList(listQuery, 1).then(res => {
        res.records.forEach(item => {
          this.options[0].options.push({
            value: item.id,
            label: item.name
          })
        })
      })
      attList(listQuery, 2).then(res => {
        res.records.forEach(item => {
          this.options[1].options.push({
            value: item.id,
            label: item.name
          })
        })
      })
      attList(listQuery, 4).then(res => {
        res.records.forEach(item => {
          this.options[2].options.push({
            value: item.id,
            label: item.name
          })
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.prize-container {
  background: #fff;
  border-radius: 4px;
  border: 1px solid #EBEEF5;

  .prize-header {
    padding: 10px 10px;
    border-bottom: 1px solid #EBEEF5;
    background-color: #F5F7FA;

    .prize-title {
      font-size: 14px;
      font-weight: 600;
      color: #303133;

      .el-icon-info {
        margin-left: 10px;
        color: #909399;
      }
    }
  }

  .prize-content {
    padding: 20px;

    .el-form-item {
      margin-bottom: 22px;
    }
  }

  .prize-type-group {
    display: flex;
    flex-direction: column;
    gap: 15px;

    .prize-type-row {
      display: flex;
      gap: 20px;
      flex-wrap: wrap;

      .el-radio {
        margin-right: 0;
        white-space: nowrap;
      }
    }
  }
}
</style>
